export default __webpack_public_path__ + "static/media/dot_Roadmap_mobile.0ca6e07a.svg";